namespace SP {
    export function serializeArray(form: HTMLFormElement) {
		let arr: any[] = [];
		Array.prototype.slice.call(form.elements).forEach((field: HTMLFormElement) => {
			if (!field.name || field.disabled || ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1) return;
			if (field.type === 'select-multiple') {
				Array.prototype.slice.call(field.options).forEach(function (option: HTMLOptionElement) {
					if (!option.selected) return;
					arr.push({
						name: field.name,
						value: option.value
					});
				});
				return;
			}
			if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked) return;
			arr.push({
				name: field.name,
				value: field.value
			});
		});
		return arr;
	}


	export function serialize(form: HTMLFormElement) {
		return serializeArray(form).map(item => encodeURIComponent(item.name) + "=" + encodeURIComponent(item.value)).join('&');
	}
}